/**
 * @param {import("axios").AxiosInstance} instance
 */

export default function tableauDashboard(instance) {
	return {
		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (config = {}) => {
			return instance.get('tableau', config)
		}
	}
}
